import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('star-rating', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('star-rating');

      return new ViewModel(params, element);
    },
  },
  template: html,
});